import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthByCodeGuardService} from './modules/auth/services/auth-by-code.guard.service';
import {AuthGuardService} from './modules/auth/services/auth.guard.service';


const routes: Routes = [
  {
  path: 'code/:code',
  loadChildren: () => (import('./modules/chat/chat.module')).then(m => m.ChatModule),
  canActivate: [AuthByCodeGuardService]
  },
  {
    path: 'chat',
    loadChildren: () => (import('./modules/chat/chat.module')).then(m => m.ChatModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'lumii-not-available/:code',
    loadChildren: () => (import('./modules//lumii-not-available/lumii-not-available.module')).then(m => m.LumiiNotAvailableModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'page-not-found', pathMatch: 'full',
    loadChildren: () => (import('./modules/page-not-found/page-not-found.module')).then(m => m.PageNotFoundModule)
  },
  {path: '', redirectTo: 'chat', pathMatch: 'full'},
  {path: '**', redirectTo: 'page-not-found', pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
